import type { TutorialStep } from './tutorial-steps'

export interface TutorialDefinition {
  id: string
  steps: readonly TutorialStep[]
}

export const tutorialDefinitions: readonly TutorialDefinition[] = [
  {
    id: 'main',
    steps: [
      {
        id: 'intro',
        targetId: 'types-explorer',
        title: 'Welcome!',
        body: 'Indexify lets you catalog pieces of information - <strong>"Objects"</strong> - by defining their structure - <strong>Type</strong> - and using dynamic views - <strong>Collections</strong> - to filter them.',
        placement: 'right',
      },
      {
        id: 'show-types-explorer',
        targetId: 'types-explorer',
        title: 'Types',
        body:
          'Here you can create and edit your object <strong>Types</strong>.\n\n' +
          'You already have an example <strong>Book</strong> type with properties to catalog and categorize books, as well as track your personal status with them.',
        placement: 'right',
      },
      {
        id: 'show-collections-explorer',
        targetId: 'collections-explorer',
        title: 'Collections',
        body:
          'Here you can view your <strong>Collections</strong> as well as use <strong>Folders</strong> to organize them.\n\n' +
          'Each <strong>Collection</strong> displays a subset of <strong>Objects</strong> of a single <strong>Type</strong> as a table view.',
        placement: 'right',
      },
      {
        id: 'show-themes',
        targetId: 'user-avatar',
        title: 'Choose your theme',
        body: 'Here you can set your preferences. For instance - switch between the dark and light <strong>Theme</strong>.',
        placement: 'bottom',
      },
    ],
  },
  {
    id: 'collection-page',
    steps: [
      {
        id: 'collection-page-intro',
        targetId: 'collection-grid',
        title: 'Collection',
        body: 'By default, a <strong>Collection</strong> shows all objects of its type.',
        placement: 'left',
      },
      {
        id: 'collection-page-columns',
        targetId: 'collection-columns-button',
        title: 'Columns',
        body: 'You can choose which <strong>Properties</strong> of <strong>Objects</strong> are displayed as columns here.',
        placement: 'bottom',
        blockTarget: true,
      },
      {
        id: 'collection-page-filters',
        targetId: 'collection-filters-button',
        title: 'Filter',
        body: 'You can define rules to filter which <strong>Objects</strong> are displayed here.',
        placement: 'bottom',
        blockTarget: true,
      },
      {
        id: 'collection-page-groupby',
        targetId: 'collection-groupby-button',
        title: 'Group by',
        body: 'You can select the <strong>Property</strong> to group the objects by here.',
        placement: 'bottom',
        blockTarget: true,
      },
      {
        id: 'collection-page-tabs',
        targetId: 'collection-tabs',
        title: 'Tabs',
        body: 'View settings are separate for each <strong>Tab</strong>. You can rename existing tabs and create new ones here.',
        placement: 'bottom',
      },
    ],
  },
]
